export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/research_summaries.153ea0c.svg";